import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap } from 'rxjs/operators';
import { sendMetricsData } from 'src/app/core/core.actions';
import { MetricsService } from 'src/app/core/metrics.service';

@Injectable()
export class CoreEffects {
    constructor(private readonly _actions$: Actions, private readonly _metricsService: MetricsService) {}

    sendMetricsData$ = createEffect(
        () =>
            this._actions$.pipe(
                ofType(sendMetricsData),
                switchMap((metrics) => {
                    return this._metricsService.postMetrics(metrics.eventName, metrics.data);
                })
            ),
        { dispatch: false }
    );
}
